export const trackerName = 'sp_analytics_staging';
export const collectorUrl = 'org-ecosia-prod1.mini.snplow.net';
export const forceSecureTracker = true;
